<template>
  <div>
    <!-- 企业客户管理 -->
    <a-card title="企业客户管理" style="margin: 20px">
      <!-- 筛选区域 -->
      <div class="selectBox">
        <div class="item">
          <span>所属机构</span>
          <DepartmentChoose :department-code.sync="paramsData.departmentCode" @change="handleQuery"></DepartmentChoose>
        </div>
        <div class="item">
          <span>登记编号</span>
          <a-input v-model.trim="paramsData.custnum" placeholder="请输入登记编号"/>
        </div>

        <div class="item">
          <span>手机号</span>
          <a-input v-model.trim="paramsData.mobile" placeholder="请输入手机号"/>
        </div>

        <div class="item">
          <span>状态</span>
          <a-select placeholder="请选择交易状态" v-model.trim="paramsData.status" allowClear style="width: 200px">
            <a-select-option v-for="(type, value) in  commonDict.AcctRegStatusConfig" :key="value" :value="value">
              <a-tag v-if="type.show" :color="type.color">{{ type.label }}</a-tag>
            </a-select-option>
          </a-select>
        </div>

        <div class="item">
          <a-button type="primary" @click="handleQuery">查询</a-button>
          <a-button @click="handleReset">重置</a-button>
        </div>

      </div>

      <!-- 表格部分 -->
      <div class="tableBox">
        <div class="handleBtn">
          <a-button type="primary" @click="religionRegBtn"> 宗教开户登记</a-button>
        </div>
        <div class="tableBody">
          <a-table :columns="columns" :data-source="tableData" :pagination="false">
            <template slot="action1" slot-scope="text, record">
              <a-button-group size="small">
                <a-button icon="eye" style="color: #34C759;" type="link" v-if="$authority('acctreg-detail')" @click="viewBtn(record)"> 查看</a-button>
                <a-button icon="edit" style="color: #ffbf00;" type="link"
                          v-if="$authority('acctreg-update') && (['PENDING', 'REJECTED', 'CANCELED'].includes(record.status))" @click="updateBtn(record)"> 修改
                </a-button>
                <a-button icon="delete" style="color: red" type="link"
                          v-if="$authority('acctreg-del') && (['PENDING', 'REJECTED', 'CANCELED'].includes(record.status))" @click="delBtn(record)"> 删除
                </a-button>
                <a-button icon="check" style="color: #7509DB;" type="link" v-if="$authority('acctreg-approval') && (['PENDING', 'OPEN_FAILED'].includes(record.status))"
                          @click="approvalBtn(record)"> 审批
                </a-button>
                <a-button icon="check" style="color: #7509DB;" type="link"
                          v-if="$authority('acctreg-opnen') && (record.status === 'APPROVED'||record.status === 'OPEN_FAILED')"
                          @click="openBtn(record)"> 开户
                </a-button>
              </a-button-group>
            </template>
          </a-table>
        </div>
      </div>

      <!-- 分页部分 -->
      <div class="paginationBox">
        <a-button :disabled="paramsData.pageNo === 1" @click="Homepage">首页</a-button>
        <a-pagination v-model.trim="paramsData.pageNo" :page-size-options="pageSizeOptions" :total="total"
                      show-size-changer :page-size="paramsData.pageSize" @change="pagechange" @showSizeChange="onShowSizeChange"
                      :item-render="itemRender"/>
        <a-button @click="Trailingpage" :disabled="paramsData.pageNo === Math.ceil(total / paramsData.pageSize)" class="Trailingpage">尾页</a-button>
      </div>
    </a-card>
  </div>
</template>

<script>
import {message} from "ant-design-vue";
import DepartmentChoose from "@/view/components/DepartmentChoose.vue";
import DeptInfo from "@/view/components/DeptInfo.vue";
import {commonDict} from "@/utils/bizDict/commonDict";

export default {
  name: 'acctregPage',
  computed: {
    commonDict() {
      return commonDict
    }
  },
  components: {DepartmentChoose, DeptInfo},
  data() {
    return {
      tableData: [],
      columns: [
        {
          title: "No",
          customRender: (text, record, index) => `${(this.paramsData.pageNo - 1) * this.paramsData.pageSize + (index + 1)}`,
          align: "center",
          width: 60
        },
        {
          title: "登记编号",
          dataIndex: "id",
          align: "center",
          width: 80,
          ellipsis: true,
        },
        {
          title: "客户名称",
          dataIndex: "accountName",
          align: "center",
          width: 100,
          ellipsis: true,
        },
        {
          title: "手机号",
          dataIndex: "mobile",
          align: "center",
          width: 60,
          ellipsis: true,
        },
        {
          title: "证件号码",
          dataIndex: "idNo",
          align: "center",
          ellipsis: true,
          width: 100,
          customRender: (text) => {
            if (!text) return "";
            let starizedText = text.replace(/^(.{6}).+(.{4}$)/, "$1****$2");
            return <a-tooltip>
              <template slot="title">{text}</template>
              {starizedText}</a-tooltip>;
          }
        },
        {
          title: "机构",
          dataIndex: "departmentId",
          align: "center",
          width: 100,
          customRender: (text) => {
            return <DeptInfo dept-id={text}></DeptInfo>;
          },
        },
        {
          title: "状态",
          dataIndex: "status",
          align: "center",
          width: 60,
          customRender: (text) => {
            const typeConfig = commonDict.AcctRegStatusConfig[text] || commonDict.AcctRegStatusConfig.default;
            return <a-tag color={typeConfig.color}>{typeConfig.label}</a-tag>;
          },
        },
        {
          title: "登记时间",
          dataIndex: "createTime",
          align: "center",
          ellipsis: true,
          width: 100,
          customRender: (text) => {
            if (!text) return "---";
            return text.split("T")[0] + " " + text.split("T")[1];
          },
        },
        {
          title: "操作",
          key: "action1",
          width: 250,
          align: "center",
          scopedSlots: {customRender: 'action1'}
        }
      ],
      pageSizeOptions: ["10", "20", "30", "40", "50"],
      total: 0,
      paramsData: {
        departmentId: undefined,
        departmentCode: '',
        pageNo: 1,
        pageSize: 10,
        custnum: "",
      },
    };
  },
  mounted() {
    this.getTableData();
  },
  methods: {
    async getTableData() {
      let data = {
        pageNo: this.paramsData.pageNo,
        pageSize: this.paramsData.pageSize,

        departmentId: this.paramsData.departmentId,
        departmentCode: this.paramsData.departmentCode,
        custnum: this.paramsData.custnum,
        status: this.paramsData.status,
        mobile: this.paramsData.mobile,

      };
      const res = await this.api.getAcctRegList(data);
      if (res.code === 200) {
        this.tableData = res.data.records;
        this.total = res.data.total;
      } else {
        message.warning(res.info);
      }
    },

    handleQuery() {
      this.paramsData.pageNo = 1;
      this.getTableData();
    },

    handleReset() {
      this.paramsData = {
        pageNo: 1,
        pageSize: 10,
        departmentId: undefined,
        custnum: "",
      };
      this.getTableData();
    },

    religionRegBtn(){
      this.$router.push({
        name: "religionReg",
      });

    },

    viewBtn(record) {
      console.log("viewBtn record", record);
      this.$router.push({
        name: "acctregDetail",
        query: {
          id: record.id,
          approval: false,
        },
      });

    },
    updateBtn(record) {
      console.log("updateBtn record", record);
      message.warning("暂不支持修改");
    },
    delBtn(record) {
      console.log("delBtn record", record);
      this.$confirm({
        title: "确定要删除吗？",
        content: "删除后无法恢复",
        okText: "确定",
        cancelText: "取消",
        onOk: async () => {
          const res = await this.api.delAcctReg(  [record.id]);
          if (res.code === 200) {
            message.success("删除成功");
            this.getTableData();
          } else {
            message.warning(res.info);
          }
        }
      })

    },
    approvalBtn(record) {
      console.log("approvalBtn record", record);
      this.$router.push({
        name: "acctregDetail",
        query: {
          id: record.id,
          approval: true,
        },
      });

    },
    openBtn(record) {
      console.log("openBtn record", record);
      this.$confirm({
        title: "确定要开户吗？",
        okText: "确定",
        cancelText: "取消",
        onOk: async () => {
          const res = await this.api.openAcctReg({
            applicationId: record.id,
          });
          if (res.code === 200) {
            message.success("开户成功");
            this.getTableData();
          } else {
            message.warning(res.info);
          }


        }
      })

    },

    onShowSizeChange(current, pageSize) {
      this.paramsData.pageNo = current;
      this.paramsData.pageSize = pageSize;
      this.getTableData();
    },

    pagechange(val) {
      this.paramsData.pageNo = val;
      this.getTableData();
    },

    Homepage() {
      if (this.total === 0) return;
      this.paramsData.pageNo = 1;
      this.getTableData();
    },

    Trailingpage() {
      if (this.total === 0) return;
      this.paramsData.pageNo = Math.ceil(this.total / this.paramsData.pageSize);
      this.getTableData();
    },

    itemRender(current, type, originalElement) {
      if (type === "prev") {
        return <a>上一页</a>;
      } else if (type === "next") {
        return <a>下一页</a>;
      }
      return originalElement;
    },
  },
};
</script>
<style lang="less" scoped>
/deep/ .ant-card-body {
  padding: 24px 34px;
}

.selectBox {
  display: flex;
  flex-wrap: wrap;

  /deep/ .item {
    margin-bottom: 20px;
    margin-right: 20px;

    // span {
    //   margin-right: 15px;
    // }
    .ant-input {
      width: 200px;
      margin-left: 20px;
    }

    .ant-select {
      width: 200px;
      margin-left: 20px;
    }
  }
}

.tableBox {
  margin-bottom: 20px;

  .handleBtn {
    margin-bottom: 20px;
  }
}

.paginationBox {
  display: flex;
  justify-content: flex-end;

  // .ant-pagination-options {
  //   float: left;
  // }

  .ant-pagination-prev,
  .ant-pagination-next,
  .ant-pagination-jump-prev,
  .ant-pagination-jump-next {
    border: 1px solid #d9d9d9;
    width: 60px;
  }
}
</style>
